import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";

function MainText({ title, subtitle, icon: Icon, width = "100%" }) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      sx={{
        width: isMobile ? "100%" : width,
        display: "flex",
        alignItems: "center",
        gap: 1,
        marginLeft:'15px'
      }}
      component={motion.div}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {Icon && <Icon sx={{ fontSize: isMobile ? 28 : 34, color: "primary.main" }} />}
      <Box>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{ fontWeight: "bold", color: "primary.main" }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body2"
            sx={{ color: "text.secondary" }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default MainText;
